import { Component, OnInit, TemplateRef } from '@angular/core';
import { ServerService } from "../server.service";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ReporteBaremoService } from "../reporte-baremo.service"
import { resultadoEncuesta } from '../models/resultadoEncuesta';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2'
import {Router} from '@angular/router';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-menureporte',
  templateUrl: './menureporte.component.html',
  styleUrls: ['./menureporte.component.css']
})
export class MenureporteComponent implements OnInit {
  public selectEncuesta: any = "SELECCIONE UNA ENCUESTA";
  public selectTipo: any = "SELECCIONE UN TIPO";
  public listEncuesta: any[] = [];
  //agregado para desplegar carnets
  public listCarnets: any[] = [];
  public informacionJefeArea: any[] = [];
  public listSeccionesUsuario: any[] = [];
  public listCarnetsPorEncuesta: any[] = [];
  public listTipo: any[] = [];
  public listCampos: any[]=[];
  public documentation: any = "";
  modalRef: BsModalRef;
  fileName= 'ReporteEncuestas.xlsx';
  public encuestados:any[]=[];
  public respuestas:any[]=[];
  public opcion:any ="";
  public registroEstudiantil=0;
 // public registroEstudiantil2: any = "SELECCIONE UNA REGISTRO";
  public seccion="";
  resultadosParaGrafica=[];
  informacionParaPDF:resultadoEncuesta[]=[];
  seleccionados:string[]=[];
  public seccionSelected;
  secciones=[];
  public generateReport=true;
  public rolLogged: string | null = null;
  public userLogged: string | null = null;
  public ROL_ADMIN = "1";
  public ROL_DOCENTE = "2";
  public ROL_COORDINADOR = "4";
  public ROL_DIRECTOR = "5";
  public ENCUESTA_ESTILOS_APRENDISAJE = 3;
  public ENCUESTA_ACTITUDES_MATEMATICA = 2;
  public ID_COORDINADOR_USUARIO = 0;
  public idCoordinadorArea: Number | null = null;
  constructor(private server: ServerService, private modalService: BsModalService, private baremoService: ReporteBaremoService,private router:Router) { }

  ngOnInit() {
    this.rolLogged = localStorage.getItem('rol');
    const usuarioRaw = localStorage.getItem('usuario');
    this.userLogged = usuarioRaw ? JSON.parse(usuarioRaw).carnet : localStorage.getItem('carnet');
    if (!this.rolLogged) {
      this.router.navigateByUrl('/login');
      return;
    }
    this.getEncuestas(this.rolLogged);
    if ( this.rolLogged == this.ROL_COORDINADOR) {
      this.getInformacionJefeArea(this.userLogged);
    }
    
  }

   async exportexcel(): Promise<void>
    {
      if (this.selectTipo=='SELECCIONE UN TIPO') {
        Swal.fire({
          text:  'Seleccione un tipo de reporte, por favor',
          icon: 'info'
        });
        //alert("Seleccione un tipo de encuesta");
      }else if(this.selectTipo=='Reporte personalizado de datos'){
        let parametros=[];
        let nombreCampo = "";
        this.listCampos.forEach(element => {
          if (element.habilitado) {
            if (element.campo=="Género") {
              let genero="0";
              nombreCampo = "genero";
              if (element.seleccionado=="Masculino") {
                genero="1";
              }
              let param={
                "name":nombreCampo,
                "value":genero
              }
              parametros.push(param);
            }else{
              if (element.campo=="Carrera") {
                nombreCampo = "carrera_id";
                const codigoCarrera = element.seleccionado.split(",").map(i => parseInt(i));
                let param={
                  "name":nombreCampo,
                  "value":codigoCarrera
                }
                parametros.push(param);
              } else if (element.campo=="Sección") {
                nombreCampo = "seccion";
                let param={
                  "name":nombreCampo,
                  "value":element.seleccionado
                }
                parametros.push(param);
              }
            }
          }
        });
        let body={
          "parametros":parametros
        }
        this.mostrarVentanaDeCarga("Cargando", "Espere mientras se genera su reporte.");

        Promise.all([
          this.server.getRespuestasExcelFiltrado(this.selectEncuesta, body),
          this.server.getEncuestadosExcelFiltrado(this.selectEncuesta, body)
        ])
        .then(([respuestas, encuestados]: [any, any]) => {
          this.respuestas = respuestas;
          this.encuestados = encuestados;

          // ✅ Generar el Excel directamente desde los datos
          const hojaEncuestados = XLSX.utils.json_to_sheet(this.encuestados);
          const hojaRespuestas = XLSX.utils.json_to_sheet(this.respuestas);

          const libro = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(libro, hojaEncuestados, 'Encuestados');
          XLSX.utils.book_append_sheet(libro, hojaRespuestas, 'Respuestas');

          XLSX.writeFile(libro, this.fileName);

          Swal.close(); // cerrar la ventana de carga al finalizar
        });
      }else if(this.selectTipo=='Reporte individual'){
        if (this.registroEstudiantil==0) {
          Swal.fire({
            text:  'Debe ingresar un registro estudiantil',
            icon: 'info'
          });
        }else{
          this.baremoService.getPerfilPorRegistro(this.selectEncuesta,this.registroEstudiantil).then((response:any)=>{
            if (response.length==0) {
              Swal.fire({
                icon: 'error',
                title: 'No encontrado',
                text: 'No se encontró reporte para este registro estudiantil.'
              })
            }else{
              let perfil=response[0].perfil_id;
              this.mostrarVentanaDeCarga("Cargando", "Espere mientras se genera su reporte.");
              this.imprimirPDF(perfil);
            }
          })
        }

      }else if(this.selectTipo=='Reporte individual por seccion'){
        if (this.seccionSelected=="") {
          Swal.fire({
            text:  'Debe ingresar una seccion',
            icon: 'info'
          });
        }else{
          this.mostrarVentanaDeCarga("Cargando", "Espere mientras se genera su reporte.");
          this.imprimirPDFPorSeccion(this.seccionSelected);
        }
      }else{
        // Crea una hoja directamente desde los arrays
        const hojaEncuestados: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.encuestados);
        const hojaRespuestas: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.respuestas);

        // Crea el libro y agrega las hojas
        const libro: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(libro, hojaEncuestados, 'Encuestados');
        XLSX.utils.book_append_sheet(libro, hojaRespuestas, 'Respuestas');

        // Exporta el archivo
        XLSX.writeFile(libro, this.fileName);
      }
    }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
    this.getCamposReporte(this.selectEncuesta, this.rolLogged, this.userLogged, this.idCoordinadorArea);
    let verificarCoordinadorArea = this.idCoordinadorArea ? this.idCoordinadorArea: "";
    if(this.selectTipo=='Reporte individual'){
        this.getCarnetsPorEncuesta(this.selectEncuesta, this.userLogged, this.rolLogged, verificarCoordinadorArea);
    }
  }
  getEncuestas(idRol) {

    this.server.getEncuestas(idRol).subscribe(data => {
      this.listEncuesta = data;
    });
  }
  getCarnets() {
    this.server.getCarnets().subscribe(data => {
      this.listCarnets = data;

    });
  }

   getSeccionesUsuario(encuesta, usuario, rol, coordinador) {
     return this.server.getSeccionesUsuario(encuesta, usuario, rol, coordinador);
  }

   getCarnetsPorEncuesta(encuestaId, usuario, rol, coordinador) {
    this.server.getCarnetsPorEncuesta(encuestaId, usuario, rol, coordinador).subscribe(data => {
      this.listCarnets = data;

    });
  }

   getInformacionJefeArea(usuario) {
    this.server.getInformacionJefeArea(usuario).subscribe(data => {
      this.informacionJefeArea = data;
      this.idCoordinadorArea = data[0]?.id ?? null;
    });
  }

  getCamposReporte(encuesta: any, rol: any, usuario: any,  coordinador: any) {
    this.server.getCamposReporte(encuesta).subscribe(data => {
      this.listCampos = data;
      this.secciones = [];

      data.forEach(element => {
        if (element.campo === "Sección") {
          this.getSeccionesUsuario(encuesta, usuario, rol, coordinador).subscribe(listSeccionesUsuario => {
            this.secciones = element.opciones.filter(opcion =>
              listSeccionesUsuario.some(item => item.seccion === opcion)
            );
          });
        }
      });
    });
  }

  encuestaSeleccionada(encuesta: any) {
    this.rolLogged = localStorage.getItem('rol');
    this.server.getTipoReportes(encuesta, this.rolLogged)
    .subscribe(data =>{
      this.listTipo=data;
      this.selectTipo = "SELECCIONE UN TIPO";
    });
  }

tipoReporteSeleccionado() {
  if (this.selectTipo !== "SELECCIONE UN TIPO") {
    const id = this.selectTipo;
    if (id === "Reporte general de datos") {
      this.mostrarVentanaDeCarga();

      forkJoin({
        respuestas: this.server.getRespuestasExcel(this.selectEncuesta),
        encuestados: this.server.getEncuestadosExcel(this.selectEncuesta)
      }).subscribe({
        next: ({ respuestas, encuestados }) => {
          this.respuestas = respuestas;
          this.encuestados = encuestados;
          setTimeout(() => Swal.close(), 200);
        },
        error: (err) => {
          console.error('Error en forkJoin:', err);
          Swal.close();
        }
      });
    }
  }
}

  imprimirPDF(perfil){
    this.generateReport=false;
    this.getInfoPDF(this.selectEncuesta,perfil);
    let resultados=[];
    let nombreEncuesta = this.selectEncuesta == this.ENCUESTA_ESTILOS_APRENDISAJE ? "Estilos de Aprendisaje":"Actitudes hacia la Matematica";
    this.baremoService.getInformacionPDF(this.selectEncuesta,perfil).then((response: any) => {
      let baremoVars ={};
      response.forEach(element => {
        resultados.push(element);
        baremoVars["res"+element.baremo]=element.puntuacion;
        baremoVars["interpretacion"+element.baremo]=element.interpretacion;
      });
      baremoVars["nombreEncuesta"]=nombreEncuesta;
      baremoVars["nombre"]=resultados[0].nombre;
      baremoVars["carne"]=resultados[0].registro.toString();
      baremoVars["carrera"]=resultados[0].carrera;
      baremoVars["curso"]=resultados[0].curso;
      baremoVars["seccion"]=resultados[0].seccion;
      baremoVars["conteoEstudiantes"]='';
      if (resultados[0].genero==1) {
        baremoVars["genero"]="Masculino";
      }else{
        baremoVars["genero"]="Femenino";
      }
      this.baremoService.getPlantilla(this.selectEncuesta).then((response:any)=>{
        let idDoc=response[0].urlPlantillaReporte;

        let variables = {
          "id": idDoc,
          "encuesta":this.selectEncuesta,
          "variables": baremoVars,
          "grafica": this.resultadosParaGrafica
        }
        this.baremoService.getReportBase64(variables).then((response: any) => {
          this.downloadPdf(response.toString(),"resultados"+resultados[0].registro.toString());
          this.resultadosParaGrafica=[];
          this.generateReport=true;
        });
      });
    });
  }

  imprimirPDFPorSeccion(seccion){
    this.generateReport=false;
    this.getInfoPDFPorSeccion(this.selectEncuesta,seccion);
    let resultados=[];
    let nombreEncuesta = this.selectEncuesta == this.ENCUESTA_ESTILOS_APRENDISAJE ? "Estilos de Aprendisaje":"Actitudes hacia la Matematica";
    let verificarCoordinadorArea = this.idCoordinadorArea ? this.idCoordinadorArea: "";
    this.baremoService.getInformacionPDFPorSeccion(this.selectEncuesta,seccion,this.userLogged, this.rolLogged, verificarCoordinadorArea).then((response: any) => {
      let baremoVars ={};
      response.forEach(element => {
        resultados.push(element);
        baremoVars["res"+element.baremo]=element.puntuacion;
        baremoVars["interpretacion"+element.baremo]=element.interpretacion;
      });
      baremoVars["nombreEncuesta"]= nombreEncuesta;
      baremoVars["nombre"]=resultados[0].nombre;
      baremoVars["carne"]="NO APLICA";
      baremoVars["carrera"]="NO APLICA";
      baremoVars["curso"]=resultados[0].curso;
      baremoVars["seccion"]=seccion;
      baremoVars["genero"]="NO APLICA";
      baremoVars["conteoEstudiantes"]=resultados[0].conteoEstudiantes.toString();
      this.baremoService.getPlantilla(this.selectEncuesta).then((response:any)=>{
        let idDoc=response[0].urlPlantillaReporte;

        let variables = {
          "id": idDoc,
          "encuesta":this.selectEncuesta,
          "variables": baremoVars,
          "grafica": this.resultadosParaGrafica
        }
        this.baremoService.getReportBase64(variables).then((response: any) => {
          this.downloadPdf(response.toString(),"resultadosSeccion"+this.seccionSelected.toString());
          this.resultadosParaGrafica=[];
          this.generateReport=true;
        });
      });
    });
  }

  downloadPdf(base64String, fileName) {
    const source = base64String;
    const link = document.createElement("a");
    link.href = source;
    link.download = `${fileName}.pdf`
    link.click();
    Swal.close();
    this.mostrarDescargaTerminada();
  }

  async getInfoPDF(id_encuesta,id_perfil):Promise<void>{
    await this.baremoService.getInformacionPDF(id_encuesta,id_perfil).then((response: any) => {
      this.informacionParaPDF=[];
      response.forEach(element => {
        let x:resultadoEncuesta=element;
        this.informacionParaPDF.push(x);
      });
      if (id_encuesta==2) {
        this.resultadosParaGrafica=[this.informacionParaPDF[1].puntuacion,this.informacionParaPDF[0].puntuacion,this.informacionParaPDF[4].puntuacion,this.informacionParaPDF[3].puntuacion,this.informacionParaPDF[2].puntuacion,0,60];
      }else{
        this.resultadosParaGrafica=[this.informacionParaPDF[0].puntuacion,this.informacionParaPDF[2].puntuacion,this.informacionParaPDF[3].puntuacion,this.informacionParaPDF[1].puntuacion];
      }

    });
  }

  async getInfoPDFPorSeccion(id_encuesta,seccion):Promise<void>{
    let verificarCoordinadorArea = this.idCoordinadorArea ? this.idCoordinadorArea: "";
    await this.baremoService.getInformacionPDFPorSeccion(this.selectEncuesta,seccion,this.userLogged, this.rolLogged, verificarCoordinadorArea).then((response: any) => {
      this.informacionParaPDF=[];
      response.forEach(element => {
        let x:resultadoEncuesta=element;
        this.informacionParaPDF.push(x);
      });
      if (id_encuesta==2) {
        this.resultadosParaGrafica=[this.informacionParaPDF[1].puntuacion,this.informacionParaPDF[0].puntuacion,this.informacionParaPDF[4].puntuacion,this.informacionParaPDF[3].puntuacion,this.informacionParaPDF[2].puntuacion,0,60];
      }else{
        this.resultadosParaGrafica=[this.informacionParaPDF[0].puntuacion,this.informacionParaPDF[2].puntuacion,this.informacionParaPDF[3].puntuacion,this.informacionParaPDF[1].puntuacion];
      }
    });
  }

mostrarVentanaDeCarga(
    titulo = 'Cargando...',
    mensaje = 'Espere un momento mientras carga la información.'
){
    Swal.fire({
      html: `
            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <div class="spinner" style="
                    width: 50px;
                    height: 50px;
                    border: 4px solid rgba(0, 0, 0, 0.1);
                    border-top: 4px solid #007bff;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin-bottom: 10px;">
                </div>
                <h2 style="margin: 0; font-size: 1.5em;">${titulo}</h2>
                <div style="margin-top: 10px;">${mensaje}</div>
            </div>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        customClass: {
          popup: 'animate__animated animate__fadeIn',
      },
    })
}

mostrarDescargaTerminada() {
    Swal.fire({
      icon: "success",
      title: "Descarga completada",
      text: "El archivo se ha generado correctamente.",
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: " Entendido",
    });
}

  logout(): void{
    localStorage.removeItem("rol")
    this.router.navigateByUrl('/login');
  }
}
